import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        sr_light_gray: '#585858',
        sr_gray: '#434343',
        sr_dark_gray: '#282828',
        primary: '#f1c232',
        secondary: '#d6b03f',
        tertiary: '#495057',
        accent: '#eb3324',
        error: '#f55a4e',
        info: '#585858',
        success: '#5cb860',
        warning: '#ffa21a'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
